import { equals, find, propEq, compose, prop, map, isEmpty } from "ramda";
import { isDefined } from "../utils/helpers";
import { DESCRIPTIVE_SIZE_UNITS_MAP } from './constants-ts';
import { PriceCurrencyEnum } from "models/producer";

export const ORDER_STATUS_CREATED = 'CREATED';
export const ORDER_STATUS_NOTIFIED_DONE = 'NOTIFIED';
export const ORDER_STATUS_NOTIFIED_FAILURE = 'NOTIFY_FAILURE';
export const ORDER_STATUS_NOTIFIED_ERROR = 'NOTIFY_ERROR';
export const ORDER_STATUS_NOTIFIED_NOTIFYING = 'NOTIFYING';

export const ORDER_STATUS_CREATED_FRONTEND = 'Created';
export const ORDER_STATUS_DONE_FRONTEND = 'Done';
export const ORDER_STATUS_SENDING_FRONTEND = 'Sending';
export const ORDER_STATUS_ERROR_FRONTEND = 'Error';
export const ORDER_STATUS_FRONTEND = [
    ORDER_STATUS_CREATED_FRONTEND,
    ORDER_STATUS_SENDING_FRONTEND,
    ORDER_STATUS_DONE_FRONTEND,
];

export const SUPERUSER_APPROVAL = {
    ADMIN_APPROVED: "ADMIN_APPROVED",
    AWAITING_APPROVAL: "AWAITING_APPROVAL",
    ADMIN_DISAPPROVED: "ADMIN_DISAPPROVED",
  };

  export const PRODUCT_STATUS = {
    MARKED_FOR_REMOVAL: 'MARKED_FOR_REMOVAL',
    DELETED: 'DELETED',
  };

export const APPLICATION_ROLES = {
    PRODUCER: 'producer',
    LOGISTICIAN: 'logistician',
    ADMIN: 'admin',
    SUPERUSER: 'superuser',
    UNAUTHORIZED: 'unauthorized',
    QUALITY: 'quality',
    STORE: 'store',
};

export const getDescriptiveSizeEnumFromValue = (value) => {
  const eV = compose(prop('enum'), find(propEq('value', value)))(DESCRIPTIVE_SIZE_UNITS_MAP)
  return isDefined(eV) ? eV : '';
}

export const getDescriptiveSizeValueFromEnum = (enumType) => {
  const v = compose(prop('value'), find(propEq('enum', enumType)))(DESCRIPTIVE_SIZE_UNITS_MAP)
  return isDefined(v) ? v : '';
}

const PRODUCT_NOTE_INPUT_TYPES = {
  INT_ARRAY: 'intArrayValue'
}

const intArrayReducer = (ack, key) => ack.concat(`${key},`);
export const PRODUCT_NOTE_TYPES_EXTRACTOR = {
  'ProductNoteIntArray': (value) => {
    if(isEmpty(value)) return value;
    return value.reduce(intArrayReducer, '').slice(0, -1);
  }
}

// TODO: Implemnt failure handling.
// TODO: Go over this
export const PRODUCT_NOTES_TYPE_TRANSFORMERS = {
  [PRODUCT_NOTE_INPUT_TYPES.INT_ARRAY]: (valueToTransform) => {
    if (valueToTransform) {
      return map(v => parseInt(v))(valueToTransform.split(','));
    } else {
      return [];
    }
  }
};

export const ORGANIZATION_SPECIFIC_FIELDS = {
  COOP: [
    {
      fieldName: 'ItemCategoriesOnline',
      inputType: PRODUCT_NOTE_INPUT_TYPES.INT_ARRAY,
      formLabel: 'Item Categories Online',
      info: 'Accepts a list of numbers, each entry should be separated by a comma.',
      transformer: PRODUCT_NOTES_TYPE_TRANSFORMERS[PRODUCT_NOTE_INPUT_TYPES.INT_ARRAY]
    }
  ]
};

// Keep this lowercased
export const ALLERGENS = [
  'abborre', 'aborr', 'alaska pollock', 'ansjovis', 'ariopsis felis', 'atlantlax', 'bergtung', 'bergtunga',
  'blå gurami', 'bläckfisk', 'blötdjur ', 'bonito', 'bredrandig ansjovis', 'cashewnöt',  'dinkel', 'drakfisk',
  'filmjölk', 'fisk', 'fjärsing', 'fläckig havskatt', 'fugu', 'gråsej', 'grädde', 'gräddfil', 'guldsparid', 'gädd',
  'gädda', 'gös', 'hajmal', 'harr', 'hasselnöt', 'havre', 'havsabborre', 'havskatt', 'hoki', 'hundhaj', 'hälleflund',
  'hälleflundra', 'jordnöt', 'kamut', 'kapkummel', 'karp', 'kedjepickerell', 'khorasanvete', 'kolja', 'korn', 'kräft',
  'kummel', 'lake', 'laktos', 'lax', 'litopenaeus vannamei', 'lupin', 'lyrtorsk', 'makadamianöt', 'makrill', 'malt',
  'mandel', 'mangrovesnapper', 'marulk', 'mjölk', 'mulle', 'mussla', 'musslor', 'mört', 'nors', 'ost', 'paranöt',
  'pekannöt', 'pigghaj', 'piggvar', 'pistasch', 'pistaschmandel',  'queenslandsnöt', 'regnbåg', 'regnbåge', 'ruda',
  'råg', 'räk', 'röd snapper', 'rödspätt', 'rödspätta', 'rödtunga', 'sandskädd', 'sandskädda', 'sardin', 'sej', 'selleri',
  'senap', 'sesam', 'sesamfrö', 'sik', 'siklöja', 'sill', 'sjurygg', 'sjötunga', 'skarpsill', 'skrubbskädda', 'slätvar',
  'smör', 'snigel', 'snäck', 'soja', 'spelt', 'strömming', 'sulfit', 'sutare', 'svaveldioxid', 'svärdfisk', 'tilapia',
  'tjockläppad multe', 'tonfisk', 'torsk', 'valnöt', 'vete', 'vitling', 'yoghurt', ' ål', 'ägg', 'öring',
  'vassle', 'bulgur', 'couscous', 'koskos', 'kouskous', 'mannagryn', 'kasein', 'pistage', 'tofu', 'krabb-', 'semolina',
  'lysozom', 'gluten', 'ostron',
];

export const ALLERGEN_EXCEPTIONS = [
  'kakaosmör', 
  'kokosmjölkspulver',
  'kokosmjölk',
  'mjölksyra',
  'maltodextrin', 
  'kakaosmör/smør',
  'kokosmjölks/mælk/melkpulver',
  'mjölksyra/mælksyre/melksyre',
  'rostad',
  'rostade',
  'glutenfri',
  'glutenfritt',
  'laktosfri',
  'laktosfritt',
  'laxerande',
];

export const ALLERGEN_EXACT_EXCEPTIONS = [
  'maltitol',
  'maltitolsirap',
  'maltitoler',
  'isomalt',
  'isomalto-oligosackarider',
  'isomaltooligosackarid',
  'kostfiber',
  'kostfibrer',
  'siktat',
  'siktad',
  'persika',
  'persikor',
  'persikojuice',
  'persikopuré',
  'persikoarom',
  'persikosaftkoncentrat',
  'persikomassa',
  'sheasmör',
  'kokossmör',
];

// Forbidden ingredients according to EU regulations (case insensitive)
export const FORBIDDEN_INGREDIENTS = [
  'oktametylcyklotetrasiloxan (d4)',
  'octamethylcyclotetrasiloxane (d4)',
  'butylphenyl methylpropional',
  'butylfenyl metylpropional',
  'lilial',
  'zinc pyrithione',
  'zinkpyrition',
  'styrene/acrylates copolymer (nano)',
  'styren/akrylat-kopolymer (nano)',
  'sodium styrene/acrylates copolymer (nano)',
  'sodium styren/akrylat-kopolymer (nano)',
  'colloidal silver (nano)',
  'kolloidalt silver (nano)',
  'gold (nano)',
  'guld (nano)',
  'platinum (nano)',
  'platina (nano)',
  'hydroxyapatite (nano)',
  'hydroxyapatit (nano)',
  'formaldehyde',
  'formaldehyd',
  'hydroquinone',
  'hydrokinon',
  'triclosan',
  'triklosan',
  'lead',
  'bly',
  'dibutyl phthalate',
  'dibutylftalat (DBP)',
  'diethylhexyl phthalate',
  'dicyclohexyl phthalate',
  'mercury',
  'kvicksilver',
  'asbest',
  'asbestos',
  'dimethylfumarate',
  'dimethylfumarat',
  'polychlorinated terphenyl',
  'polyklorerade terfenyl'
];

// Function to check if a word is in the exception list or contains an exception
export const isAllergenException = (word) => {
  // Remove special characters like asterisks
  const cleanWord = word.toLowerCase().replace(/[*]/g, '');
  
  // Direct match with any exception
  if (ALLERGEN_EXCEPTIONS.some(exception => cleanWord === exception)) {
    return true;
  }
  
  // Check for exceptions at the beginning of the word
  if (ALLERGEN_EXCEPTIONS.some(exception => cleanWord.startsWith(exception))) {
    return true;
  }
  
  // Check for slash variations
  if (cleanWord.includes('/')) {
    // Check if any part of a slash-separated word matches an exception
    const parts = cleanWord.split(/[\/]/);
    
    // Check if any of the base exceptions match the start of any part
    return ALLERGEN_EXCEPTIONS.some(exception => {
      const exceptionBase = exception.split('/')[0];
      return parts.some(part => part.startsWith(exceptionBase));
    });
  }
  
  return false;
};


export const PRODUCT_CLASSIFICATIONS= ['KLASS ”EXTRA”', 'KLASS 1', 'KLASS 2'];

export const RECYCLING_AMOUNT = [
  { displayName: '1 SEK', value: 1 },
  { displayName: '2 SEK', value: 2 },
  { displayName: '3 SEK', value: 3 },
];

export const getPercentageValues = () => {
    const values = new Array(35).fill(0.1);
    for (let i = 1; i < 36; i++) {
        values[i - 1] = (values[i - 1] * i).toFixed(1);
    }
    values.splice(0, 0, 0.0);
    return values;
};

export const PRICE_CURRENCY = [
  { displayName: 'SEK', value: PriceCurrencyEnum.SEK },
  { displayName: 'EUR', value: PriceCurrencyEnum.EUR },
  { displayName: 'NOK', value: PriceCurrencyEnum.NOK },
  { displayName: 'DKK', value: PriceCurrencyEnum.DKK },
];
